module.exports = __webpack_public_path__ + "static/media/inquiry_black.ff80f943.svg";